export default __webpack_public_path__ + "5d82014a89d0412f9c883a72e280096f.png";